export default "__VITE_ASSET__JdZZLOUH__"